import React from 'react'
import injectSheet from 'react-jss'
import { connect } from 'react-redux'
import styles from './style'
import { COLORS } from 'helpers/globals'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class ProgressRing extends React.Component {
  constructor(props) {
    super(props)
    this.radius = 18
    this.stroke = 2
    this.normalizedRadius = this.radius - this.stroke * 2
    this.circumference = this.normalizedRadius * 2 * Math.PI
  }

  render() {
    const { props: { progress, classes, failed, snapshotCount }, stroke, radius } = this
    const strokeDashoffset = this.circumference - (progress / 100 * this.circumference)

    return (
      failed || snapshotCount === 0
      ? (
        <span style={{ position: 'relative', height: radius * 2, width: radius * 2, display: 'inline-block' }}>
          <span className={classes.iconDanger}>
            <FontAwesomeIcon
              icon='ban'
              color={COLORS.danger}
            />
          </span>
        </span>
      ) : (
        <span style={{ position: 'relative', height: radius * 2, width: radius * 2, display: 'inline-block' }}>
          <span className={classes.iconProcessing}>
            <FontAwesomeIcon
              icon='sync'
              spin
              color={[0, 100].includes(progress) ? COLORS.primary : COLORS.quaternary}
            />
          </span>
          <svg
            height={radius * 2}
            width={radius * 2}
            transform='rotate(-90)'
            style={{ display: progress === 0 ? 'none' : 'inherit' }}
            >
            <circle
              stroke={progress === 100 ? '#fff' : COLORS.primary}
              fill='transparent'
              strokeWidth={stroke}
              strokeDasharray={this.circumference}
              style={{ strokeDashoffset }}
              r={this.normalizedRadius}
              cx={radius}
              cy={radius}
              />
          </svg>
        </span>
      )
    )
  }
}

const progressText = (failed, format, percent, snapshotCount) => {
  if (snapshotCount === 0) return 'You must have at least one device to export projects.  Please add a device.'
  if (failed) return 'Export failed'

  switch (percent) {
    case 0:
      return 'Starting export'
    case 100:
      return 'Bundling files'
    default:
      return `Generating ${format}, ${percent}% complete`
  }
}

const mapStateToProps = ({ exports }) => ({ exports, exporting: !EXPORT && !!exports.length })

class ExportStatus extends React.Component {
  render() {
    const { props: { classes, exports } } = this
    return (
      <div className={classes.container}>
        {
          exports
            .sort((a, b) => a.startTime - b.startTime)
            .map(({ id, failed, percentageComplete, format, snapshotCount }) => (
              <div className={classes.progressContainer} key={id}>
                <ProgressRing progress={percentageComplete} classes={classes} failed={failed} snapshotCount={snapshotCount} />
                <div className={classes.progressText}>{progressText(failed, format, percentageComplete, snapshotCount)}</div>
              </div>
            )
          )
        }
      </div>
    )
  }
}

export default connect(mapStateToProps)(injectSheet(styles)(ExportStatus))



// WEBPACK FOOTER //
// ./src/components/ExportStatus/index.js